<template>
  <section class="lms-container">
    <div class="content">
      <div class="breadcrumb" style="border: none !important;"></div>

      <div class="form-actions" style="padding-left:15px;  padding-right:15px;">
        <button
          :disabled="saving"
          v-on:click="saveUser"
          type="submit"
          class="btn btn-primary btn-medium"
        >
          <i class="icon-save"></i>&nbsp;Gravar
        </button>
        <a id="save_student_" v-on:click="$router.push({ name: 'users'})" class="btn btn-medium">
          <i class="icon-circle-arrow-left"></i>&nbsp;Voltar
        </a>
      </div>

      <tabs>
        <tab title="Usuário">
          <div style="margin-bottom:30px;" class="form-fields with-content-inner">
            <fieldset>
              <user-edit ref="userEditComponent" v-on:type="changeType" :user="user" />
              <student-edit
                ref="studentEditComponent"
                v-if="showStudent && student"
                :student="student"
              />
              <teacher-edit ref="teacherEditComponent" v-if="showTeacher" :teacher="teacher" />
              <address-edit ref="addressEditComponent" v-if="showAddress" :address="address" />
            </fieldset>
          </div>
        </tab>
        <tab title="Avaliações">
          <quiz-list v-if="user.id" @update="getQuestions" :quizList="quizList" />
        </tab>
        <tab title="Inscrições">
          <subscription-list
            v-if="user.id"
            @update="getSubscriptions"
            :subscriptions="subscriptions"
          />
        </tab>
      </tabs>
    </div>
  </section>
</template>


<script>
import axios from "axios";
import StudentEdit from "../Utils/UserTypes/StudentEdit.vue";
import UserEdit from "../Utils/UserTypes/UserEdit.vue";
import AddressEdit from "../Utils/AddressEditTeste.vue";
import TeacherEdit from "../Utils/UserTypes/TeacherEdit.vue";
import Alert from "./Alert";
import QuizList from "./User/QuizList";
import SubscriptionList from "./User/SubscriptionList";

export default {
  data() {
    return {
      user: this.$store.getters.userEdit,
      saving: false,
      showMessage: false,
      showAddress: false,
      showTeacher: false,
      showStudent: false,
      student: {},
      address: {},
      teacher: {},
      quizList: [],
      subscriptions: []
    };
  },
  components: {
    SubscriptionList,
    QuizList,
    "student-edit": StudentEdit,
    "address-edit": AddressEdit,
    "user-edit": UserEdit,
    "teacher-edit": TeacherEdit,
    alert: Alert
  },
  methods: {
    getSubscriptions() {
      const path = this.$global.endpoint + "/subscription/getall";
      axios
        .post(path, { userId: this.user.id })
        .then(res => {
          this.subscriptions = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    changeType(type) {
      if (type == 1) {
        this.showStudent = true;
        this.showAddress = true;
        this.showTeacher = false;
      } else if (type == 0) {
        this.showStudent = false;
        this.showAddress = false;
        this.showTeacher = false;
      } else if (type == 2) {
        this.showStudent = false;
        this.showTeacher = true;
        this.showAddress = false;
      }
    },

    saveUser() {
      this.saving = true;
      if (this.$refs.userEditComponent.hasErrors()) {
        this.saving = false;
        return;
      }

      var post_data = {};

      post_data.user = this.user;

      if (this.showAddress) {
        /*
        if (this.$refs.addressEditComponent.hasErrors()) {
          this.saving = false;
          return;
        }
        */
        post_data.address = this.address;
      }

      if (this.showStudent) {
        if (this.$refs.studentEditComponent.hasErrors()) {
          this.saving = false;
          return;
        }
        post_data.student = this.student;
      }

      if (this.showTeacher) {
        if (this.$refs.teacherEditComponent.hasErrors()) {
          this.saving = false;
          return;
        }
        post_data.teacher = this.teacher;
      }

      let path = this.$global.endpoint + "/user/save";

      switch (this.user.type) {
        case 0:
          path = this.$global.endpoint + "/user/admin/save";
          break;
        case 1:
          path = this.$global.endpoint + "/user/admin/student/save";
          break;
        case 2:
          path = this.$global.endpoint + "/user/admin/teacher/save";
          break;
        default:
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao salvar os dados"
          });
      }
      axios
        .post(path, post_data)
        .then(res => {
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Dados do usuário salvos com sucesso"
          });
          this.saving = false;
        })
        .catch(error => {
          this.saving = false;
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    getQuestions() {
      const path = this.$global.endpoint + "/quiz/execution/getall";
      axios
        .post(path, {
          userId: this.user.id
        })
        .then(res => {
          this.quizList = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  mounted() {
    if (this.user && this.user.id) {
      this.getSubscriptions();
      this.getQuestions();
    }
    if (this.user == undefined) {
      this.user = {};
    } else {
      this.changeType(this.user.type);

      const path = this.$global.endpoint + "/user/getuser";
      axios
        .post(path, { user: this.user })
        .then(res => {
          this.user.id = res.data.user.id;
          if (res.data.hasOwnProperty("address")) {
            this.address = res.data.address;
          }

          if (res.data.hasOwnProperty("student")) {
            this.student = res.data.student;
          }

          if (res.data.hasOwnProperty("teacher")) {
            this.teacher = res.data.teacher;
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>
